import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import CustomModal from "../../../../components/modal/custom-modal";
import { Button, TableColumnsType, TableProps, Typography, Flex } from "antd";
import { ExamInfoDtoProps } from "../../../../types/course";
import { getExamHistory } from "../../../../service/courses";
import moment from "moment";
import { formatNumber } from "../../../../utils/format";
import { displayExamSessionStatus } from "../../../../utils/app";
import { EyeOutlined } from "@ant-design/icons";
import { ExamSessionStatus } from "../../../../constants/course";
import TableData from "../../../../components/table-data/TableData";
import { useNavigate, useParams } from "react-router-dom";
import { routesConfig } from "../../../../config/routes";

const { Link } = Typography;

interface ViewDetailTestProps {
  data: ExamInfoDtoProps;
  courseName?: string;
  studentId: number;
}

function ViewDetailTest({ data, studentId, courseName }: ViewDetailTestProps) {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const blockId = data?.blockId;
  const { courseId } = useParams();
  const [histories, setHistories] = useState<any>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect(() => {
    const getHistoryDetailExam = async () => {
      if (studentId && blockId && isOpen) {
        try {
          setLoading(true);
          const res = await getExamHistory({
            blockId,
            studentId,
          });
          setHistories(res.data.data);
        } finally {
          setLoading(false);
        }
      }
    };
    getHistoryDetailExam();
  }, [studentId, blockId, isOpen]);

  const columns: TableColumnsType<any> = [
    {
      title: t("Thời gian nộp bài", "Thời gian nộp bài"),
      dataIndex: "doneTime",
      key: "doneTime",
      render(value, record, index) {
        return (
          <>
            {value
              ? moment(value).format("HH:mm:ss - DD/MM/YYYY")
              : moment(record?.updatedDate).format("HH:mm:ss - DD/MM/YYYY")}
          </>
        );
      },
    },
    {
      title: t("Kết quả (Câu)", "Kết quả (Câu)"),
      key: "minimumScore",
      render(value, record, index) {
        return record?.moocFinalExamResults ? (
          <>
            {record?.moocFinalExamResults?.trueQuestions || 0}/
            {record?.moocFinalExamResults?.totalQuestions || 0}
          </>
        ) : (
          "-"
        );
      },
    },
    {
      title: t("Điểm", "Điểm"),
      key: "courseScore",
      render(value, record, index) {
        return <>{formatNumber(record?.moocFinalExamResults?.totalPoints)}</>;
      },
    },
    {
      key: t("Trạng thái nộp bài", "Trạng thái nộp bài"),
      title: t("Trạng thái nộp bài", "Trạng thái nộp bài"),
      dataIndex: "status",
      render: (value, record) => (
        <>
          <Flex align="center" gap={12}>
            <span>{displayExamSessionStatus(value)}</span>{" "}
            {(value === ExamSessionStatus.CHECK_SUCCESS ||
              value === ExamSessionStatus.READY_TO_CHECK ||
              value === ExamSessionStatus.MARKING) && (
              <Button
                className="view-btn"
                onClick={() =>
                  navigate(
                    `${routesConfig.courseManagement}/${courseId}/${routesConfig.evaluationAndDiscussion}/${blockId}/exercise/${record?.sessionId}`,
                    {
                      state: {
                        courseName: courseName,
                        courseId: courseId,
                        unitName: data?.name,
                        blockId: blockId,
                        studentName: record.studentFullname,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </Button>
            )}
          </Flex>
        </>
      ),
    },
  ];

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  return (
    <CustomModal
      getModalStatus={setIsOpen}
      width={1000}
      title={data?.name}
      footer={null}
      content={
        <div className="mt-2">
          <TableData
            loadingTable={loading}
            dataTable={histories?.reverse()}
            dataColumns={columns}
            pagination={true}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            handleTableChangeProps={handleTableChange}
            totalRecords={histories?.reverse()?.length}
          />
        </div>
      }
    >
      <Link>{t("Xem", "Xem")}</Link>
    </CustomModal>
  );
}

export default ViewDetailTest;
